import Device from '@/helpers/Device';
import DeviceType from '@/helpers/DeviceType';
import StorageHandler, {
  STORE_KEY,
  STORE_VALUE,
  STORE_VALUE_NAME,
} from '@/helpers/StorageHandler';
import router from '@/router';
import store from '@/store';
import KeyHandlingTizen from './Tizen';
import KeyHandlingLG from './LG';


export const KEYS = {
  BACK: 'VK_BACK',
  GOBACK: 'VK_GOBACK',
  ENTER: 'VK_ENTER',
  UP: 'VK_UP',
  RIGHT: 'VK_RIGHT',
  DOWN: 'VK_DOWN',
  LEFT: 'VK_LEFT',
  CHANNEL_UP: 'CHANNEL_UP',
  CHANNEL_DOWN: 'CHANNEL_DOWN',
  KEY_0: '0',
  KEY_1: '1',
  KEY_2: '2',
  KEY_3: '3',
  KEY_4: '4',
  KEY_5: '5',
  KEY_6: '6',
  KEY_7: '7',
  KEY_8: '8',
  KEY_9: '9',
  POWER: 'POWER',
  CHANNEL_GUIDE: 'CHANNEL_GUIDE',
  INFO: 'INFO',
  EXIT: 'EXIT',
  LIST: 'LIST',
  VIEW: 'VIEW',
  APP: 'APP',
  PORTAL: 'PORTAL',
  PAGE_DOWN: 'PAGE_DOWN',
  PAGE_UP: 'PAGE_UP',
  RED: 'RED',
  GREEN: 'GREEN',
  YELLOW: 'YELLOW',
  BLUE: 'BLUE',
  HOME: 'HOME',
  CONTENT: 'VK_CONTENT',
};

export const keyHandler = {
  mounted() {
    // if (process.env.TEST_KEY_HANDLING) {
    // }
    if(DeviceType.isTizen) {
      console.log('===================mounted-keyHandler=Tizen');
      KeyHandlingTizen.registerKeys();
      KeyHandlingTizen.setPowerStateListener();
    }
    // LG: Key-Registrierung sofort falls hcap bereit, sonst auf 'hcap-ready' warten
    if (window.lgVersion) {
      if (typeof hcap !== 'undefined') {
        console.log('===================mounted-keyHandler=LG');
        KeyHandlingLG.registerKeys();
      } else {
        window.addEventListener('hcap-ready', function() {
          console.log('===================hcap-ready-keyHandler=LG');
          KeyHandlingLG.registerKeys();
        }, { once: true });
      }
    }
    window.addEventListener('keydown', this.handleTestKeys);
    // window.addEventListener('message', this.eventHandling);
  },
  beforeDestroy() {
    console.log('destroy');
    if (DeviceType.isTizen) {
      KeyHandlingTizen.unregisterKeys();
      KeyHandlingTizen.unsetPowerStateListener();
    }
    /*
    if (DeviceType.isLG) {
      KeyHandlingLG.unregisterKeys();
      KeyHandlingLG.unsetPowerStateListener();
    }
    */
    // if (process.env.TEST_KEY_HANDLING) {
    // }
    window.removeEventListener('keydown', this.handleTestKeys);
    // window.removeEventListener('message', this.eventHandling);
  },
  methods: {
    async eventHandling(event = {}) {
      console.log('EVENT HANDLING=>', 'charCode:', event.charCode, 'code:', event.code, 'key:', event.key, 'keyCode:', event.keyCode, 'vk_key:', event.vk_key);
      // const data = event.data;
      const key = event.vk_key;
      console.log('KEY: ', key);
      switch (key) {
        case KEYS.HOME:
        case KEYS.EXIT:
        case KEYS.PORTAL:
        case KEYS.CONTENT:
          router.push({ name: 'Home' });
          return;
        /*
        case KEYS.GOBACK:
          console.log("=======================EVENTKEY", key);
          event.preventDefault();
          event.stopPropagation();
          router.go(-1);
          return;
        */
        case KEYS.POWER:
          //if(!hasWebapis) {
            const currentState = StorageHandler.get(STORE_KEY.POWER_STATE);
            const nextState =
              currentState === STORE_VALUE.POWER_OFF
                ? STORE_VALUE.POWER_ON
                : STORE_VALUE.POWER_OFF;
            console.log('CURRENT STATE:', currentState, ' => NEXT STATE:', nextState);
            StorageHandler.save(STORE_KEY.POWER_STATE, nextState).then(() => {
              if (nextState === STORE_VALUE.POWER_OFF) {
                console.log('dispatch turnOff:', nextState);
                store.dispatch('device/turnOff');
              } else {
                console.log('dispatch turnOn:', nextState);
                store.dispatch('device/turnOn');
              }
            });
          //}
          return;
      }
      this.eventHandler(key, event);
    },
    eventHandler(key, event) {
      //console.log("======================EVENTKEY", key);
      switch (key) {
        //case KEYS.DOWN:
        case KEYS.GOBACK:
        case KEYS.BACK:
          event.preventDefault();
          event.stopPropagation();
          router.go(-1);
          break;
      }
    },
    handleTestKeys(e) {
      let vk_key = null;
      if(!e.code && !window.tizen && navigator.userAgent.indexOf("LGE") > 0 && navigator.userAgent.indexOf("STB-5500") > 0) e.code = e.key = e.keyIdentifier;
      console.log('TESTKEY=>', 'charCode:', e.charCode, 'code:', e.code, 'key:', e.key, 'keyCode:', e.keyCode, 'which:', e.which, 'vk_key:', e.vk_key, 'altKey:', e.altKey, 'ctrlKey:', e.ctrlKey);
      switch (e.code) {
        case 'Up':
        case 'ArrowUp':
          vk_key = KEYS.UP;
          break;
        case 'Down':
        case 'ArrowDown':
          vk_key = KEYS.DOWN;
          break;
        case 'Right':
        case 'ArrowRight':
          vk_key = KEYS.RIGHT;
          break;
        case 'Left':
        case 'ArrowLeft':
          vk_key = KEYS.LEFT;
          break;
        case 'PageDown':
          vk_key = KEYS.CHANNEL_DOWN;
          break;
        case 'PageUp':
          vk_key = KEYS.CHANNEL_UP;
          break;
        case 'Digit0':
          vk_key = KEYS.KEY_0;
          break;
        case 'Digit1':
          vk_key = KEYS.KEY_1;
          break;
        case 'Digit2':
          vk_key = KEYS.KEY_2;
          break;
        case 'Digit3':
          vk_key = KEYS.KEY_3;
          break;
        case 'Digit4':
          vk_key = KEYS.KEY_4;
          break;
        case 'Digit5':
          vk_key = KEYS.KEY_5;
          break;
        case 'Digit6':
          vk_key = KEYS.KEY_6;
          break;
        case 'Digit7':
          vk_key = KEYS.KEY_7;
          break;
        case 'Digit8':
          vk_key = KEYS.KEY_8;
          break;
        case 'Digit9':
          vk_key = KEYS.KEY_9;
          break;
        case 'Submit':
        case 'Enter':
          vk_key = KEYS.ENTER;
          break;
        case 'PrintScreen':
          vk_key = KEYS.YELLOW;
          break;
        case 'Home':
        case 'Portal':
        case 'Content':
        case 'XF86SysMenu':
        case 'XF86Ambient':
        case 'SamsungTVPlus':
        case 'GamingHub':
        case 'ArtMode':
        case 'Apps':
        case 'HotelInfo':
        case 'HotelMenu':
        case 'MyRoom':
          vk_key = KEYS.HOME;
          break;
        case 'Escape':
        case 'Exit':
        case 'XF86Exit':
        case 'GoBack':
        case 'Backspace':
          vk_key = KEYS.BACK;
          break;
        default:
          vk_key = e.key;
      }
      switch (e.keyCode) {
        case 10071: //
        case 10182: //XF86Exit
        case 602:   //
        case 1001:  //
        case 10133: //XF86SysMenu
        case 10232: //XF86Ambient
        case 10258: //SamsungTVPlus
        case 10259: //GamingHub
        case 10260: //ArtMode
        case 10077: //Apps
        case 10300: //HotelInfo
        case 10301: //HotelMenu
        case 10302: //Interactive
        case 10303: //MyRoom
          vk_key = KEYS.HOME;
          break;
        /*
        case 1001:
          vk_key = KEYS.EXIT;
          break;
        case 602:
          vk_key = KEYS.PORTAL;
          break;
        */
        case 461:
          vk_key = KEYS.BACK;//GOBACK
          break;
        case 1006:
          vk_key = KEYS.LIST;
          break;
        case 711:
          vk_key = KEYS.VIEW;
          break;
        case 427:
          vk_key = KEYS.CHANNEL_UP;
          break;
        case 428:
          vk_key = KEYS.CHANNEL_DOWN;
          break;
        case 409:
          vk_key = KEYS.POWER;
          break;
        case 457:
          vk_key = KEYS.INFO;
          break;
        case 458:
          vk_key = KEYS.CHANNEL_GUIDE;
          break;
        case 48:
          vk_key = KEYS.KEY_0;
          break;
        case 49:
          vk_key = KEYS.KEY_1;
          break;
        case 50:
          vk_key = KEYS.KEY_2;
          break;
        case 51:
          vk_key = KEYS.KEY_3;
          break;
        case 52:
          vk_key = KEYS.KEY_4;
          break;
        case 53:
          vk_key = KEYS.KEY_5;
          break;
        case 54:
          vk_key = KEYS.KEY_6;
          break;
        case 55:
          vk_key = KEYS.KEY_7;
          break;
        case 56:
          vk_key = KEYS.KEY_8;
          break;
        case 57:
          vk_key = KEYS.KEY_9;
          break;
        case 403:
          vk_key = KEYS.RED;
          break;
        case 404:
          vk_key = KEYS.GREEN;
          break;
        case 405:
          vk_key = KEYS.YELLOW;
          break;
        case 406:
          vk_key = KEYS.BLUE;
          break;
      }
      const modEvent = e;
      modEvent.vk_key = vk_key;
      // console.log("==========================modEvent", modEvent);
      // console.log('here');
      // window.postMessage({ key: vk_key });
      this.eventHandling(modEvent);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/keyHandler/index.js